import useCurrentNikeUser from "@/app/(main)/account/settings/hooks/useCurrentNikeUser";

const useCurrentUserEmail = () => {
  const nikeUser = useCurrentNikeUser();
  return nikeUser?.email;
};

export default useCurrentUserEmail;
